import { Divider, Paper } from "@material-ui/core";
import { FC, useEffect, useState } from "react";
import { IDataResponse, STATUS_CODE } from "src/framework/providers/api";
import { PedidosProvider } from "src/providers/pagamentos/PedidoProvider";
import theme from "src/theme/light";
import { PagamentoListagem } from "../PagamentoListagem";
import './styles.scss';
import { useObservable } from "src/framework/store/storeUtil";
import { PedidoType } from "src/types";
import { getComponentes, getUpload, verficarServicoCupomDesconto } from "src/store/global.store";
import { LocalStorage } from "src/framework/commons/LocalStorage";
import { CardPedido } from "./CardPedido";
import { PedidoStore } from "src/store/vendas/PedidoStore";
import { doLogOut, isLoggedIn$, notifierStore } from "src/framework/store";
import { SessionStorage } from "src/framework/commons";

const pedidosProvider = new PedidosProvider();

const Pagamento: FC = () => {
    const [pedidos, setPedidos] = useState<PedidoType[]>([]);

    const pedidoCodigoRedirect = useObservable<string | null | undefined>(PedidoStore.getPedidoCodigoRedirectSubject());
    const pedidoRedirect = useObservable<PedidoType | null | undefined>(PedidoStore.getPedidoRedirectSubject());
    const [widthScreen, setWidthScreen] = useState<number>(window.innerWidth);

    const [statusServicoCupom, setStatusServicoCupom] = useState<{ ativo: boolean, img_url: string }>({
        ativo: false,
        img_url: ""
    })

    const init = async () => {
        await Promise.all([
            getComponentes(),
            getUpload(),
            pedidoCodigoRedirect === null || pedidoCodigoRedirect === undefined ? verficarServicoCupomDesconto() : null,
            getPedido(),
        ]).then(() => {

            const statusCupom = LocalStorage.get("solar.servicoCupom", true)
            if (statusCupom) {
                setStatusServicoCupom(statusCupom.data)
            }
        })

    }

    const getPedido = async (): Promise<void> => {
        const response: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedidoCodigoRedirect);
        if (response.statusCode === STATUS_CODE.OK) {
            setPedidos(response.data);
            if (response.message && response.message !== "Ok") {
                notifierStore.setNotifier({
                    title: "Aviso",
                    content: response.message,
                    timeOut: 3500,
                    onClose: async () => {
                        notifierStore.setOpen(false)
                        const msgs: string[] = []

                        if (Array.isArray(response.message)) {
                            response.message.forEach(msg => {
                                msgs.push(...msg)
                            })
                        }

                        if (msgs.some((msg: string) => msg.includes("vigência") && msg.includes("encerrado"))) {
                            const redirectURL = await doLogOut();
                            if (redirectURL) {
                                window.location.href = redirectURL
                                LocalStorage.removeAll();
                                SessionStorage.removeAll();
                                isLoggedIn$.next(false);
                            }
                        }

                    }
                })
                notifierStore.setOpen(true)
            }
            if (pedidoCodigoRedirect) {
                if (response.data) {
                    let _pedidoRedirect = response.data.find((p) => p.codigo_venda === pedidoCodigoRedirect)
                    if (!_pedidoRedirect && pedidoCodigoRedirect.includes("KIT")) {
                        const codigoVenda = pedidoCodigoRedirect.replace("KIT", "KOND")
                        _pedidoRedirect = response.data.find((p) => p.codigo_venda === codigoVenda)
                    }
                    PedidoStore.setPedidoRedirect(_pedidoRedirect || null)
                }
            }
        }
    }

    const getPedidoById = async (codigoVenda: string): Promise<void> => {
        const response: IDataResponse<PedidoType[]> = await pedidosProvider.getPedidos(pedidoCodigoRedirect);
        if (response.statusCode === STATUS_CODE.OK) {
            const pedidosState = [...pedidos];
            const pedidoReload = response.data.find((p) => p.codigo_venda === codigoVenda);
            const idx = pedidosState.findIndex((p) => p.codigo_venda === codigoVenda);
            if (idx > -1 && pedidoReload) {
                pedidosState[idx] = pedidoReload;
                setPedidos(pedidosState);
            }

        }
    }

    useEffect(() => {
        init();
    }, [])

    useEffect(() => {
        if (pedidoCodigoRedirect) {
            getPedido().then(() => {
                verficarServicoCupomDesconto().then(() => {
                    const statusCupom = LocalStorage.get("solar.servicoCupom", true)
                    if (statusCupom) {
                        setStatusServicoCupom(statusCupom.data)
                    }
                });
            });
        }
    }, [pedidoCodigoRedirect])

    useEffect(() => {
        window.addEventListener('resize', () => {
            const { innerWidth } = window;
            setWidthScreen(innerWidth);
        });
    }, []);

    return <>        
        <div className="row Pagamento">
            <div className="X12" style={{paddingRight: "0"}}>
                {pedidoRedirect && <>
                    <div className="X12 PedidoVigenteDiv">
                        <Paper className="PedidoVigentePaper" elevation={3} >
                            <CardPedido
                                pedido={pedidoRedirect}
                                statusServicoCupom={statusServicoCupom}
                                widthScreen={widthScreen}
                                onReload={() => {
                                    getPedido();
                                }}
                            />
                        </Paper>
                    </div>
                </>}
                <div className="X12 PagamentosDiv">
                    <Paper className="PagamentosPaper" elevation={0} >
                        <div className="X12 Listagem">
                            <div className="X12 Divisor">
                                <strong style={{ color: theme.palette.grey[500], fontWeight: "500"}}>Caso tenha outros pedidos pendentes, acompanhe abaixo:</strong>
                                <Divider />
                            </div>
                            <div className="X12">
                                <PagamentoListagem
                                    pedidos={pedidos?.filter((p) => p.codigo_venda !== pedidoRedirect?.codigo_venda) || []}
                                    statusServicoCupom={statusServicoCupom}
                                    onReload={(codigoVenda: string) => {
                                        getPedidoById(codigoVenda);
                                    }}
                                />
                            </div>
                        </div>
                    </Paper>
                </div>
            </div>

        </div>
    </>
}



export { Pagamento }